(function () {
  /* Scroll Listener Global */
  function setupGlobalNavScroll() {
    var nav = document.getElementById('fv-main-nav');
    if (!nav) return;

    function checkScroll() {
      var scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (scrollPos > 20) {
        nav.classList.add('is-scrolled');
      } else {
        nav.classList.remove('is-scrolled');
      }
    }

    window.addEventListener('scroll', checkScroll, { passive: true });
    document.addEventListener('scroll', checkScroll, { passive: true });
    window.addEventListener('resize', checkScroll, { passive: true });
    checkScroll();
  }

  /* Formateador de moneda para Shopify */
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* Gestor de Carrito AJAX */
  function getCart() {
    return fetch('/cart.js')
      .then(function(res) {
        if (!res.ok) throw new Error('Error al obtener el carrito');
        return res.json();
      });
  }

  /* Actualiza TODOS los contadores del sitio web (Header + Drawer) */
  function syncAllCartCounters(cart) {
    var count = cart.item_count;

    // 1. Buscar cualquier badge/contador en TODO el documento HTML
    var countEls = document.querySelectorAll('[data-fv-cart-count], [data-fv-cart-count-badge], .fv-cart-count');
    countEls.forEach(function(el) {
      el.textContent = count;
      if (el.classList.contains('fv-cart-count')) {
        el.style.display = count > 0 ? 'flex' : 'none';
      }
    });

    // 2. Buscar cualquier indicador de subtotal en TODO el documento HTML
    var subtotalEls = document.querySelectorAll('[data-fv-cart-subtotal]');
    subtotalEls.forEach(function(el) {
      el.textContent = formatMoney(cart.total_price);
    });
  }

  /* Renderiza o actualiza la sección del Carrito usando el Section Rendering API de Shopify */
  function refreshCartDrawer() {
    return getCart().then(function(cart) {
      syncAllCartCounters(cart);

      // Detecta la sección activa dinámicamente para no depender de 'cart-drawer.liquid'
      var sectionEl = document.querySelector('[data-fv-section]');
      var sectionId = sectionEl ? sectionEl.getAttribute('id').replace('fv-section-', '') : null;
      
      var url = window.location.pathname;
      if (sectionId) {
        url += '?section_id=' + sectionId;
      }

      return fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newDrawer = doc.querySelector('[data-fv-cart-drawer]');
          var currentDrawer = document.querySelector('[data-fv-cart-drawer]');

          if (currentDrawer && newDrawer) {
            var isOpen = currentDrawer.classList.contains('is-open');
            currentDrawer.innerHTML = newDrawer.innerHTML;
            if (isOpen) {
              currentDrawer.classList.add('is-open');
            }
          }
        });
    });
  }

  /* DELEGACIÓN GLOBAL DE EVENTOS PARA EL CARRITO */
  document.addEventListener('click', function (e) {
    // A) Botón "Agregar al carrito"
    var addBtn = e.target.closest('.fv-add-to-cart-btn');
    if (addBtn) {
      e.preventDefault();
      var variantId = addBtn.getAttribute('data-variant-id');

      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Error al agregar al carrito');
        return refreshCartDrawer();
      })
      .then(function() {
        var cartDrawer = document.querySelector('[data-fv-cart-drawer]');
        if (cartDrawer) {
          cartDrawer.classList.add('is-open');
        }
      })
      .catch(function(err) { console.error('Error al agregar producto:', err); });
      return;
    }

    // B) Abrir / Cerrar Drawer
    var cartToggle = e.target.closest('[data-fv-cart-toggle]');
    if (cartToggle) {
      e.preventDefault();
      e.stopPropagation();
      var cartDrawer = document.querySelector('[data-fv-cart-drawer]');
      if (cartDrawer) {
        cartDrawer.classList.toggle('is-open');
      }
      return;
    }

    // Cerrar drawer al hacer clic fuera de él
    var cartWrap = document.querySelector('.fv-cart-wrap');
    var cartDrawerEl = document.querySelector('[data-fv-cart-drawer]');
    if (cartDrawerEl && cartDrawerEl.classList.contains('is-open')) {
      if (cartWrap && !cartWrap.contains(e.target)) {
        cartDrawerEl.classList.remove('is-open');
      }
    }

    // C) Controles de Cantidad dentro del Drawer (+ / - / eliminar)
    var lineItem = e.target.closest('[data-fv-cart-line]');
    if (lineItem) {
      var key = lineItem.getAttribute('data-key');
      var qtySpan = lineItem.querySelector('.fv-cart-line-qty span');
      var currentQty = parseInt(qtySpan ? qtySpan.textContent.trim() : '1', 10);
      var newQty = currentQty;

      if (e.target.closest('[data-fv-qty-increase]')) {
        newQty = currentQty + 1;
      } else if (e.target.closest('[data-fv-qty-decrease]')) {
        newQty = Math.max(0, currentQty - 1);
      } else if (e.target.closest('[data-fv-cart-remove]')) {
        newQty = 0;
      } else {
        return;
      }

      e.preventDefault();

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Error al actualizar item');
        return refreshCartDrawer();
      })
      .catch(function(err) { console.error('Error al modificar carrito:', err); });
    }
  });

  /* Inicialización de Componentes no relacionados con el Carrito */
  function initFatalVisionSection(root) {
    if (!root || root.dataset.fvInit) return;
    root.dataset.fvInit = 'true';

    /* Nav Mobile */
    var burger = root.querySelector('.fv-nav-burger');
    var mobileMenu = root.querySelector('.fv-nav-mobile-menu');
    if (burger && mobileMenu) {
      burger.addEventListener('click', function () {
        mobileMenu.classList.toggle('is-open');
      });
    }

    /* Niveles Selector (1 a 5) */
    var levelBtns = root.querySelectorAll('.fv-level-btn');
    var levelImgs = root.querySelectorAll('.fv-level-img');
    var progressBar = root.querySelector('#fv-level-progress-bar');
    var stepIndicator = root.querySelector('#fv-level-step-indicator');
    var bigNum = root.querySelector('#fv-big-num');
    var topBadge = root.querySelector('#fv-top-badge');
    var infoNum = root.querySelector('#fv-info-num');
    var infoBac = root.querySelector('#fv-info-bac');
    var infoTag = root.querySelector('#fv-info-tag');
    var infoFill = root.querySelector('#fv-info-fill');
    var prevBtn = root.querySelector('#fv-prev-level');
    var nextBtn = root.querySelector('#fv-next-level');

    var currentLevel = 0;
    var totalLevels = levelBtns.length;

    function updateLevel(index) {
      if (index < 0 || index >= totalLevels) return;
      currentLevel = index;

      levelBtns.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === currentLevel);
      });
      levelImgs.forEach(function (img, i) {
        img.classList.toggle('is-active', i === currentLevel);
      });

      var activeBtn = levelBtns[currentLevel];
      if (!activeBtn) return;

      var name = activeBtn.getAttribute('data-name');
      var bac = activeBtn.getAttribute('data-bac');
      var tag = activeBtn.getAttribute('data-tag') || '';
      var pct = ((currentLevel + 1) / (totalLevels || 1)) * 100;

      if (progressBar) progressBar.style.width = pct + '%';
      if (stepIndicator) stepIndicator.textContent = (currentLevel + 1) + ' / ' + totalLevels;
      if (bigNum) bigNum.textContent = (currentLevel + 1 < 10 ? '0' : '') + (currentLevel + 1);
      if (topBadge) topBadge.textContent = name;
      if (infoNum) infoNum.textContent = (currentLevel + 1 < 10 ? '0' : '') + (currentLevel + 1);
      if (infoBac) infoBac.textContent = 'BAC ' + bac;
      if (infoTag) infoTag.textContent = tag;
      if (infoFill) infoFill.style.width = pct + '%';

      if (prevBtn) prevBtn.disabled = currentLevel === 0;
      if (nextBtn) nextBtn.disabled = currentLevel === totalLevels - 1;
    }

    levelBtns.forEach(function (btn, i) {
      btn.addEventListener('click', function () { updateLevel(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { updateLevel(currentLevel - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { updateLevel(currentLevel + 1); });

    /* Actividades Interactivas (Así se usa) */
    var actCards = root.querySelectorAll('.fv-asi-act-card');
    var actImgs = root.querySelectorAll('.fv-asi-img');
    var actDots = root.querySelectorAll('#fv-asi-dots .dot');
    var statNum = root.querySelector('#fv-asi-stat-num');
    var statLbl = root.querySelector('#fv-asi-stat-lbl');
    var statSubText = root.querySelector('#fv-asi-stat-sub-text');
    var statPct = root.querySelector('#fv-asi-stat-pct');
    var statFill = root.querySelector('#fv-asi-stat-fill');
    var statDesc = root.querySelector('#fv-asi-stat-desc');
    var pillTitle = root.querySelector('#fv-asi-pill-title');
    var pillCount = root.querySelector('#fv-asi-pill-count');
    var asiPrev = root.querySelector('#fv-asi-prev');
    var asiNext = root.querySelector('#fv-asi-next');

    var currentAct = 0;
    var totalActs = actCards.length;

    function updateActivity(index) {
      if (index < 0 || index >= totalActs) return;
      currentAct = index;

      actCards.forEach(function (card, i) {
        card.classList.toggle('is-active', i === currentAct);
      });
      actImgs.forEach(function (img, i) {
        img.classList.toggle('is-active', i === currentAct);
      });
      actDots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentAct);
      });

      var activeCard = actCards[currentAct];
      if (!activeCard) return;

      var stat = activeCard.getAttribute('data-stat');
      var lbl = activeCard.getAttribute('data-lbl');
      var pct = activeCard.getAttribute('data-pct');
      var name = activeCard.getAttribute('data-name');
      var desc = activeCard.getAttribute('data-desc');

      if (statNum) statNum.textContent = stat;
      if (statLbl) statLbl.textContent = lbl;
      if (statPct) statPct.textContent = pct;
      if (statFill) statFill.style.width = pct;
      if (statDesc) statDesc.textContent = desc;
      if (pillTitle) pillTitle.textContent = name;
      if (pillCount) {
        pillCount.textContent = (currentAct + 1 < 10 ? '0' : '') + (currentAct + 1) + ' / ' + (totalActs < 10 ? '0' : '') + totalActs;
      }

      if (statSubText) {
        var valNum = parseInt(stat, 10);
        if (!isNaN(valNum)) {
          statSubText.textContent = (100 - valNum) + '% menos ' + lbl.toLowerCase() + ' que la visión normal';
        } else {
          statSubText.textContent = 'Deterioro notable respecto a la visión normal';
        }
      }

      if (asiPrev) asiPrev.disabled = currentAct === 0;
      if (asiNext) asiNext.disabled = currentAct === totalActs - 1;
    }

    actCards.forEach(function (card, i) {
      card.addEventListener('click', function () { updateActivity(i); });
    });
    actDots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { updateActivity(i); });
    });
    if (asiPrev) asiPrev.addEventListener('click', function () { updateActivity(currentAct - 1); });
    if (asiNext) asiNext.addEventListener('click', function () { updateActivity(currentAct + 1); });

    /* FAQ */
    root.querySelectorAll('.fv-faq-item').forEach(function (item) {
      var q = item.querySelector('.fv-faq-q');
      if (!q) return;
      q.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        root.querySelectorAll('.fv-faq-item').forEach(function (i) { i.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupGlobalNavScroll();
    document.querySelectorAll('[data-fv-section]').forEach(initFatalVisionSection);
    getCart().then(syncAllCartCounters);
  });

  document.addEventListener('shopify:section:load', function (e) {
    setupGlobalNavScroll();
    var el = e.target.querySelector('[data-fv-section]');
    if (el) initFatalVisionSection(el);
  });
})();